import React, { Fragment } from 'react';
import {autorun, IReactionDisposer, toJS} from 'mobx'
import MonthPicker from '../MonthPicker'
import Col from '../base-components/Col'
import Input from '../base-components/Input'
import DropDownList, { DataListItem } from '../base-components/DropDownList'
import {observer} from 'mobx-react'
import * as ActionEvent from "../../utils/events/actionEvent";
import {addContextualError,
  addError, BindedComponentError, clearError,
  parseError, removeContextualError} from '../../utils/error-utils'
import {isAndroidWebview,isIosWebview,isMobileDevice} from '../../utils/browser-utils'
import AmazonButton from '../AmazonPayComponent/AmazonWidget'
import {LocalDate} from "@js-joda/core";
import { CreditCardInput } from '../CreditCartInput';
import {BaseUIComponentProps} from './BaseUIComponent';
import { IDomainData, IUIPaymentMethodDef, CustomerWallet, PaymentMethodDef } from '../../datatypes';
import { AuthorizationData, AuthorizationResponse } from 'paypal-checkout-components';

import { toBoolean } from '../../utils/config-utils';

import {paypalCheckout} from 'braintree-web';
import {venmo} from 'braintree-web';
import {client} from 'braintree-web';
const {MDBIcon, MDBRow, MDBInput,MDBSpinner, MDBCollapse, MDBCard, MDBCardBody} = require('mdbreact')

const accountToNotToggleTwice = ['DC','CC','DD']; //These accounts when selected twice shouldn't redo any operations.
const codesByCategory = {
  creditCards: [
    'MC',
    'VISA',
    'DISC',
    'AMEX'
  ],
  braintree: [
    'PAYPAL_ACCOUNT',
    'VENMO',
    'PAYPAL_CREDIT'
  ],
  amazon: [
      'AMAZON_PAY'
  ],
  debitCards: [
    'MC_DEBIT',
    'VISA_DEBIT'
  ],
  directDebits: [
    'CHQ',
    'SAV'
  ]
}
const PaymentMethodIcons:React.FC<{typeCodes:string|string[]}> = ({typeCodes}) => {
  // format typeCodes to array
//   if (!Array.isArray(typeCodes)) 
  let typeCodesArray:string[];
  if(Array.isArray(typeCodes)){ 
    typeCodesArray = typeCodes;
  }else{ 
    typeCodesArray = [typeCodes];
  }

  // directDebits only use "eCheck as icon"
  for (let ddCode of codesByCategory.directDebits){
    let idx = typeCodes.indexOf(ddCode);
    if (idx >= 0) typeCodesArray[idx] = "eCheck";
  }

  let set = new Set(typeCodesArray);
  typeCodesArray = Array.from(set);

  return <Fragment>
      {
        typeCodesArray.map((pmCode:string) => (
            <img    key={pmCode}
                    className={pmCode === 'AMAZON_PAY' ? 'pm-amazon-logo' : ''}
                    src={`${process.env.PUBLIC_URL}/images/payment-methods/${pmCode}.png`}
                    alt={`${pmCode} payment method icon`}
            />
        ))
      }
  </Fragment>
}

type PaymentMethodData = IDomainData & {
    PaymentMethodCategory:string;
    AccountNumber:string|null;
    ReEnterAccountNumber:string|null;
    MaskedAccountNumber:string|null;
    Cvv:string|null;
    ExpiryDate:string|null;
    CardHolderName:string|null;
    FiName:string|null;
    BankTransitNumber:string|null;
    BankId:string|null;
    PaymentMethodTypeCode:string|null;
    AcceptDDAgreementFlag:string; // Y or N
    SaveForReuseFlag:string; // Y or N
    Nonce:string|null;
    ProfileToken:string|null;
}

interface PaymentMethodProps extends BaseUIComponentProps{
    metadata:IUIPaymentMethodDef;
    PaymentMethod:PaymentMethodData ;
    customerWallets:CustomerWallet[];
    paymentMethodDef:PaymentMethodDef[];
    brainTreeEnvironment?:any; 
    venmoProfileId?:string;
    payWithPreviousPmSupported?:boolean;

    amazonClientId?:string, 
    amazonMerchantId?:string, 
    amazonSandbox?:string;
}

interface PaymentMethodState {
    selectedCategory?:string;
    accountNumberOnMount?:string;
    showAmazonCheckout:boolean;
    AmazonPayLabel?:string;
    lastSelectedCategory?: string;

    newlyAdded: {[key:string]: {
                                    Nonce: string,
                                    CardHolderName: string,
                                    AccountNumber: string,
                                    PaymentMethodTypeCode: string,
                                    label: string,
                                }};
    years: {value:string, text:string, checked:boolean, icon?:string, disabled:boolean}[];

    amazonOrderId?:string;
    AmazonUserName?:string;
    amazonError?: string;
    AmazonCustomerId?:string;
    amazonStatus?:string;

    venmoInstance?: any;
    venmoError?:string;
    braintreeTokenLoaded?: boolean;

    loadingClientToken?:boolean;
    braintreePMReady?:boolean;
}

class PaymentMethod extends React.Component<PaymentMethodProps,PaymentMethodState> {
  private  isShowDisposer: IReactionDisposer|undefined;

  constructor(props:PaymentMethodProps) {
    super(props)

    this.state = {
      selectedCategory: this.props.PaymentMethod.PaymentMethodCategory as string,
      newlyAdded: {},
      accountNumberOnMount: this.props.PaymentMethod.AccountNumber as string,
      showAmazonCheckout: false,
      AmazonPayLabel: 'Amazon Pay',
      lastSelectedCategory: undefined,
      years: [

      ]
    }

    let currentYear = new Date().getFullYear();
    for(let year = currentYear; year < (currentYear + 10); year++) {
      this.state.years.push({
        value: `${year}`,
        text: `${year}`,
        checked: false,
        icon: undefined,
        disabled: false
      })
    }
  }
  componentDidMount() {
    let {formBean, PaymentMethod}= this.props;
    
    // when enablePopUpView = true, the base view should keep all the UI information
    if(PaymentMethod.Cvv && (!formBean.__ui__only || (formBean.__ui__only && !formBean.__ui__only.enablePopUpView))) {
      // console.log("clearing cvv for compliance");
      PaymentMethod.Cvv = '';
    }

    //keeps checking if venmoState in formBean has correct conditions.
    //Calls success and error functions for venmo.
    this.isShowDisposer = autorun(() => {
      let venmoState = formBean.__ui__only.venmoState ? formBean.__ui__only.venmoState : null;
      let venmoSuccessInfoLoaded = venmoState && (venmoState.status === "VENMO_PENDING" && !venmoState.error && venmoState.payload && venmoState.category === "VENMO");
      let venmoErrorInfoLoaded = venmoState && (venmoState.error && venmoState.status === "VENMO_ERR");
      if(venmoErrorInfoLoaded || venmoSuccessInfoLoaded) {
        //setting the previous unmounted state details back after mounting
        this.setState({
          venmoInstance: venmoState!.venmoInstance,
          braintreeTokenLoaded: true
        },()=>{
          if(venmoErrorInfoLoaded) this.handleVenmoError(venmoState!.error!);
          else if (venmoSuccessInfoLoaded) this.handleVenmoSuccess(venmoState!.payload, venmoState!.category!)
        })
      }
    });

    formBean.validators.push(this.isValid)
  }

  componentWillUnmount() {
    this.isShowDisposer && this.isShowDisposer();
  }

  amazonError = (eCode: string, eMsg: string | undefined) =>{
    console.log("Amazon pay error: ", eCode+":"+eMsg);
    this.setState({
      showAmazonCheckout: !this.state.showAmazonCheckout,
      amazonError: eCode ? (eCode+": "+eMsg) : (eMsg ? eMsg: undefined)
    })
  }

  updateAmazonStatus = (response: { amazonResponseProfile: any; orderId: string; status: string; }) => {
    if(response.amazonResponseProfile){
      let profile = response.amazonResponseProfile;
      this.setState({
        AmazonPayLabel: profile.amazonUserEmail ? profile.amazonUserEmail : 'Amazon Pay',
        AmazonUserName: profile.amazonUserName ? profile.amazonUserName : undefined,
        AmazonCustomerId: profile.amazonCustomerId ? profile.amazonCustomerId : undefined
      })
    }
    if(response && response.orderId && response.status) {
      this.setState({
        amazonOrderId: response.orderId,
        amazonStatus: response.status,
        showAmazonCheckout: !this.state.showAmazonCheckout
      }, () => {
        if (this.state.amazonStatus === 'COMPLETED' && this.state.amazonOrderId) {
          this.toggleCollapse("AMAZON_PAY", null);
        }
      })
    }

  }
  // see DEV repo: /pframe/src/java/com/paymentus/common/rt/config/ClientConfig.java
  isACHReEnterEnabled = ()=> {
      let achChannels = ((this.props.formBean.clientConfigOptions||{}).ACH_REENTRY_CHANNELS || '').trim().split(',');

      return toBoolean((this.props.formBean.clientConfigOptions||{}).ACH_REENTRY_ENABLED||'', false) 
             || achChannels.some(x=>x==='otp') || achChannels.some(x=>x === 'global');

  }
  isValid = () => {
    let {PaymentMethod, metadata, formBean, ctx} = this.props;
    let objectName = PaymentMethod._edgeName;
    let errorProps:BindedComponentError = {
      error: '',
      code: '',
      domainObject: PaymentMethod,
      attrName: '',
      formBean: formBean,
      objectName: objectName,
      objectId: PaymentMethod.Id,
      metadata: {label: ''}
    }
    let category = PaymentMethod.PaymentMethodCategory;
    if(!category) {
      addContextualError(formBean, 'paymentMethodError', 'Please select a payment method');
      return false;
    }else removeContextualError(formBean, 'paymentMethodError');
    let valid = true;
    let ACHReEnterEnabled = this.isACHReEnterEnabled();

    switch(category){
      case 'LAST_USED_PM':
        //this option was only available because it came from backend and there is nothing to validate
        return true;
      case 'DC':
      case 'CC':
        if(!PaymentMethod.AccountNumber) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}'
          errorProps.code = 'attribute.empty'
          errorProps.attrName = 'AccountNumber';
          (errorProps.metadata as {label:string}).label = 'Account Number'
          addError(errorProps);
        }else{
            let cardType = this.identifyCardType(PaymentMethod.AccountNumber, category);
            if(!cardType) {
              valid = false;
              errorProps.error = 'Please enter the valid {attribute.label}'
              errorProps.code = 'attribute.invalidError';
              errorProps.attrName = 'AccountNumber';
              (errorProps.metadata as {label:string}).label = 'Account Number'
              addError(errorProps);
            }
        }
        if(!PaymentMethod.ExpiryDate){
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}'
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'ExpiryDate';
          (errorProps.metadata as {label:string}).label = 'Expiry Date'
          addError(errorProps);
        }else{
          let expiryDate = LocalDate.parse(PaymentMethod.ExpiryDate);
          let now = LocalDate.now();
          now = LocalDate.of(now.year(), now.monthValue(), 1);

          if(expiryDate < now){

            valid = false;
            errorProps.error = 'Please select {attribute.label} in the future';
            errorProps.code = 'ExpiryDate.invalidError';
            errorProps.attrName = 'ExpiryDate';
            (errorProps.metadata as {label:string}).label = 'Expiry Date';
            addError(errorProps);
          }
        }

        if(!PaymentMethod.CardHolderName) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}'
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'CardHolderName';
          (errorProps.metadata as {label:string}).label = 'Card Holder Name'
          addError(errorProps);
        }

        if(!PaymentMethod.Cvv) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}'
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'Cvv';
          (errorProps.metadata as {label:string}).label = 'CVV'
          addError(errorProps);
        }else{
            let cvvRegex = /^[0-9]{3,4}$/;
            if(!cvvRegex.test(PaymentMethod.Cvv)){
              valid = false;
              errorProps.error = 'Please enter the valid {attribute.label}';
              errorProps.code = 'attribute.invalidError';
              errorProps.attrName = 'Cvv';
              (errorProps.metadata as {label:string}).label = 'CVV'
              addError(errorProps);
            }
        }
        break;
      case 'DD':
        if(!['CHQ','SAV'].includes(PaymentMethod.PaymentMethodTypeCode||'')) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}';
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'PaymentMethodTypeCode';
          (errorProps.metadata as {label:string}).label = 'Account Type'
          addError(errorProps);
        }
        if(!PaymentMethod.AccountNumber) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}'
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'AccountNumber';
          (errorProps.metadata as {label:string}).label = 'Account Number'
          addError(errorProps);
        }else if(ACHReEnterEnabled){
            if((PaymentMethod.AccountNumber||'') !== (PaymentMethod.ReEnterAccountNumber||'')){
                valid = false;
                errorProps.error = 'Please enter matching account number';
                errorProps.code = 'attribute.invalidError';
                errorProps.attrName = 'ReEnterAccountNumber';
                (errorProps.metadata as {label:string}).label = 'Re-Enter Account Number'
                addError(errorProps);
                console.debug(`AccountNumber=${PaymentMethod.AccountNumber} ReEnterAccountNumber=${PaymentMethod.ReEnterAccountNumber}`);
            }
        }
        if(!PaymentMethod.CardHolderName) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}';
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'CardHolderName';
          (errorProps.metadata as {label:string}).label = 'Card Holder Name'
          addError(errorProps);
        }
        if(!PaymentMethod.FiName) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}';
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'FiName';
          (errorProps.metadata as {label:string}).label = 'Bank Name'
          addError(errorProps);
        }
        if(!PaymentMethod.BankId) {
          valid = false;
          errorProps.error = 'Please enter the {attribute.label}';
          errorProps.code = 'attribute.empty';
          errorProps.attrName = 'BankId';
          (errorProps.metadata as {label:string}).label = 'Routing Number'
          addError(errorProps);
        } else if(!PaymentMethod.BankTransitNumber) {
          valid = false;
          errorProps.error = 'Please enter the valid {attribute.label}';
          errorProps.code = 'attribute.invalidError';
          errorProps.attrName = 'BankTransitNumber';
          (errorProps.metadata as {label:string}).label = 'Routing Number'
          addError(errorProps);
        }

        if(PaymentMethod.AcceptDDAgreementFlag !== 'Y'){
          errorProps.error = 'Please read and accept and ACH agreement';
          errorProps.code = 'acceptDDAgreementFlag.invalid';
          errorProps.attrName = 'AcceptDDAgreementFlag';
          (errorProps.metadata as {label:string}).label = '';
          addError(errorProps);
          valid = false;
        }
        break;
    }
    return valid;
  }



  toggleCollapse = (category: string | null | undefined, 
                    e?: React.MouseEvent<HTMLDivElement, MouseEvent> | null) => {
    //if user clicks same paymentMethod again, then no need to go through all the below steps. (Eg: clearing fields, errors etc)
    if(category === this.state.lastSelectedCategory && accountToNotToggleTwice.includes(category||'')) return;
    if(e) e.preventDefault();
    let {PaymentMethod, formBean} = this.props;
    //since the payment method has toggled, the errors don't apply
    delete PaymentMethod._errors;
    let objectName = PaymentMethod._edgeName;
    let errorProps = {
      domainObject: PaymentMethod,
      formBean: formBean,
      objectName: objectName,
      objectId: PaymentMethod.Id,
    }

    clearError(errorProps, true);

    //all newly added payment methods on the page such as paypal will have "_NEWLY_ADDED" category code at the end
    let isNewlyAdded = (category || '').endsWith('_NEWLY_ADDED');
    let wallet = (category || '').startsWith('WALLET');
    let categoryCode = (category || '').replace('_NEWLY_ADDED','');
    PaymentMethod.PaymentMethodCategory = wallet ? categoryCode.split("_")[0] : categoryCode;
    PaymentMethod.AccountNumber = null;
    PaymentMethod.ReEnterAccountNumber = null;
    PaymentMethod.MaskedAccountNumber = null;
    PaymentMethod.Cvv = null;
    PaymentMethod.ExpiryDate = null;
    PaymentMethod.CardHolderName = null;
    PaymentMethod.FiName = null;
    PaymentMethod.BankTransitNumber = null;
    PaymentMethod.BankId = null;
    PaymentMethod.PaymentMethodTypeCode = null;
    PaymentMethod.AcceptDDAgreementFlag = 'N';
    PaymentMethod.Nonce = null;
    PaymentMethod.ProfileToken = null;

    switch(categoryCode){
      case 'AMAZON_PAY':
        PaymentMethod.AccountNumber = this.state.amazonOrderId||null;
        PaymentMethod.CardHolderName = this.state.AmazonUserName||null;
        PaymentMethod.PaymentMethodTypeCode = categoryCode;
        break;
      case 'PAYPAL_ACCOUNT':
      case 'PAYPAL_CREDIT':
      case 'VENMO':
        PaymentMethod.AccountNumber = this.state.newlyAdded && this.state.newlyAdded.VENMO ? this.state.newlyAdded.VENMO.AccountNumber : null;
        PaymentMethod.CardHolderName =  this.state.newlyAdded && this.state.newlyAdded.VENMO ? this.state.newlyAdded.VENMO.CardHolderName : null;
        PaymentMethod.Nonce = this.state.newlyAdded && this.state.newlyAdded.VENMO ? this.state.newlyAdded.VENMO.Nonce : null;
        PaymentMethod.PaymentMethodTypeCode = categoryCode;
        break;
      default:
        break;
    }
    //since the payment method has toggled, the category errors don't apply
    this.setState({selectedCategory: category||undefined, 
                   lastSelectedCategory:category||undefined, 
                   amazonError:undefined, 
                   venmoError: undefined}, () => {
      if(category === 'LAST_USED_PM'){
        let lastPM = this.props.customerWallets.find((pm) => pm.LastUsedPm)!;
        PaymentMethod.PaymentMethodTypeCode = lastPM.PaymentMethodType;
        PaymentMethod.MaskedAccountNumber = lastPM.MaskedAccountNumber;
        this.calculateConvFee();
      }

      if(isNewlyAdded){
        let newPM = this.state.newlyAdded[categoryCode];
        if(categoryCode.startsWith('PAYPAL_')){
          PaymentMethod.Nonce = newPM.Nonce;
          PaymentMethod.CardHolderName = newPM.CardHolderName;
          PaymentMethod.AccountNumber = newPM.AccountNumber;
        }
        this.calculateConvFee();
      }

      if(wallet){
        let walletEntry = this.props.customerWallets.find(
            (cw) => !cw.LastUsedPm && cw.ProfileCode == categoryCode.split("_")[1])!;
        PaymentMethod.PaymentMethodTypeCode = walletEntry.PaymentMethodType;
        PaymentMethod.ProfileToken = walletEntry.ProfileCode;

        this.calculateConvFee();
      }

      if(codesByCategory.braintree.includes(category||'')){
        this.selectBraintreePM();
      }

      if(codesByCategory.amazon.includes(category||'') && e!=null){
        this.setState({
            showAmazonCheckout: true
        })
        this.calculateConvFee();
      }

      if(this.props.formBean.__ui__only.venmoState && this.state.venmoInstance) this.props.formBean.__ui__only.venmoState.venmoInstance = this.state.venmoInstance;
      if(this.props.formBean.__ui__only.venmoState && this.state.braintreeTokenLoaded != null) this.props.formBean.__ui__only.venmoState.tokenLoaded = this.state.braintreeTokenLoaded;

    })
  }
  async selectBraintreePM() {
    let {PaymentMethod, formBean} = this.props;
    this.setState({loadingClientToken: true});
    await ActionEvent.submitRequests(this.props.formBean, ["PaymentFacade.getClientToken"]);
    this.setState({loadingClientToken: false});
    let clientToken = PaymentMethod.ClientToken;
    let category = PaymentMethod.PaymentMethodCategory;
    if(!clientToken) {
      console.log("Unable to get braintree client token");
      addContextualError(formBean, 'brainTreeError', 'Unable to get braintree client token');
      return;
    }
    if(category=== 'VENMO'){
      this.initBraintreeClientVenmo();
    } else {
      this.initBraintreeClient()
    }

  }
  initBraintreeClientVenmo() {
    let {PaymentMethod,venmoProfileId} = this.props;
    let clientToken = PaymentMethod.ClientToken as string;
    let category = PaymentMethod.PaymentMethodCategory;
    let pmType = PaymentMethod.PaymentMethodTypeCode;
    // Create braintree client.
    client.create({
      authorization: clientToken
    }, (clientErr, clientInstance) => {
      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization
      // is invalid.
      if (clientErr) {
        console.error('Error creating client: ', clientErr);
        this.setState({venmoError: 'Error creating Venmo:'+clientErr});
        return;
      }

      venmo.create({
        client: clientInstance,
        // Add allowNewBrowserTab: false if your checkout page does not support
        // relaunching in a new tab when returning from the Venmo app. This can
        // be omitted otherwise.
        allowNewBrowserTab: false,
        profileId: venmoProfileId
      }, (venmoErr, venmoInstance) => {
        if (venmoErr) {
          console.log('Error creating Venmo: ', venmoErr);
          this.setState({venmoError: 'Error creating Venmo: '+venmoErr});
          return;
        }

        // Verify browser support before proceeding.
        if (!venmoInstance.isBrowserSupported() && !isIosWebview() && !isAndroidWebview()) {
          console.log('Browser does not support Venmo');
          this.setState({
            venmoError: "Your browser does not support Venmo"
          });
          //unselect current category
          this.toggleCollapse(null);
          return;
        }

        this.setState({braintreeTokenLoaded: true, venmoInstance: venmoInstance});

      });
    });

  }

  onClickVenmoButton(){
    const {venmoInstance, selectedCategory} = this.state;
    if(selectedCategory !== 'VENMO'){
      console.log("Venmo is not selected");
      return;
    }
    if(!venmoInstance){
      console.log("Venmo instance in not initialized");
      return;
    }


    let braintreeTokenLoaded = this.state.braintreeTokenLoaded;
    venmoInstance.tokenize( (tokenizeErr: any, payload: any) => {
      //Tokenize method of venmo unmounts the component.
      //As a result some of the state info is reset after mounting back.
      //That info is passed to the formBean to be stored before losing it. Eg: Venmo instance details, tokenloaded checks and the payload from tokenize function.
      if (tokenizeErr) {
          // @ts-ignore
        this.props.formBean.__ui__only.venmoState = {};
        this.props.formBean.__ui__only.venmoState!.payload = null;
        this.props.formBean.__ui__only.venmoState!.category = null;
        this.props.formBean.__ui__only.venmoState!.status = "VENMO_ERR";
        this.props.formBean.__ui__only.venmoState!.error = tokenizeErr;
        this.props.formBean.__ui__only.venmoState!.venmoInstance = venmoInstance;
        this.props.formBean.__ui__only.venmoState!.tokenLoaded = !!braintreeTokenLoaded;
      } else {
          // @ts-ignore
        this.props.formBean.__ui__only.venmoState = {};
        this.props.formBean.__ui__only.venmoState!.payload = payload;
        this.props.formBean.__ui__only.venmoState!.category = selectedCategory;
        this.props.formBean.__ui__only.venmoState!.status = "VENMO_PENDING";
        this.props.formBean.__ui__only.venmoState!.error = undefined;
        this.props.formBean.__ui__only.venmoState!.venmoInstance = venmoInstance;
        this.props.formBean.__ui__only.venmoState!.tokenLoaded = !!braintreeTokenLoaded;
      }
    });
  }

  handleVenmoError = (err: { code: string; message: string; }) => {
    if (err.code === 'VENMO_CANCELED') {
      console.log('App is not available or user aborted payment flow');
    } else if (err.code === 'VENMO_APP_CANCELED') {
      this.setState({loadingClientToken: false})
      console.log('User canceled payment flow');
    } else {
      console.log('An error occurred with venmo:', err.message);
      this.setState({
        venmoError: err.message
      });
    }
  }
  handleVenmoSuccess = (payload: { nonce: any; details: { username: any; }; }, pmType: string) => {
    // Send the payment method nonce to your server, e.g. by injecting
    // it into your form as a hidden input.
    console.log('Got a payment method nonce:', payload.nonce);
    // Display the Venmo username in your checkout UI.
    console.log('Venmo user:', payload.details.username);

    let selectedPmType = pmType;

    let newPM = {
      Nonce: payload.nonce,
      CardHolderName: payload.details.username,
      AccountNumber: payload.details.username,
      PaymentMethodTypeCode: selectedPmType,
      label: payload.details.username,
    };
    this.addNewBraintreePm(selectedPmType, newPM);
  }
  addNewBraintreePm(selectedPmType: string, newPM: { Nonce: any; CardHolderName: any; AccountNumber: any; PaymentMethodTypeCode: any; label: any; }){
    //show new paypal paymentmethod
    //hide paypal checkout button
    this.setState({
      braintreePMReady: true,
      newlyAdded: {
        ...this.state.newlyAdded,
        [selectedPmType]: newPM
      }
    },() => {
      this.toggleCollapse(selectedPmType+"_NEWLY_ADDED");
    });
  }
  async initBraintreeClient() {
    let {PaymentMethod,brainTreeEnvironment} = this.props;
    let clientToken = PaymentMethod.ClientToken as string;
    let pmType = PaymentMethod.PaymentMethodTypeCode!;
    let env = brainTreeEnvironment;
    let offerCredit: boolean;
    let label = '';
    if (pmType == 'PAYPAL_CREDIT') {
      offerCredit = true;
      label = 'credit';
    }
    else { // this is PAYPAL_ACCOUNT
      offerCredit = false;
      label = 'paypal';
    }

    client.create({
      authorization: clientToken
    }, (clientErr: any, clientInstance: any) => {
      // Stop if there was a problem creating the client.
      // This could happen if there is a network error or if the authorization is invalid.
      if (clientErr) {
        console.error('Error creating client:', clientErr);
        return;
      }

      paypalCheckout.create(
          {client: clientInstance}, // options
          // callback function 
          (paypalCheckoutErr: any, 
           paypalCheckoutInstance: {
                createPayment: (arg0: {
                                        flow: string; // Required
                                        offerCredit: any;
                                    }) => Promise<string>; 
                tokenizePayment: (arg0: AuthorizationData, arg1: (err: any, payload: any) => void) => Promise<AuthorizationResponse>;
            }
           ) => {
                // Stop if there was a problem creating PayPal Checkout.
                // This could happen if there was a network error or if it's incorrectly configured.
                if (paypalCheckoutErr) {
                    // TODO: missing error handling ???
                    console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                    return;
                }
                window.paypal.Button.render(
                {
                    env: env,
                    style: {// @ts-ignore
                        label: label, size: 'responsive', tagline: false, shape: 'rect', color: 'white'
                    },
                    payment: () => {
                        return paypalCheckoutInstance.createPayment({
                                                                        flow: 'vault', // Required
                                                                        offerCredit: offerCredit
                                                                    });
                    },

                    onAuthorize: (data, actions) => {
                        return paypalCheckoutInstance.tokenizePayment(data, (err: any, payload: { nonce: any; 
                                                                                                details: { email: any; 
                                                                                                            payerId: any; }; 
                                                                                                }
                                                                            ) => 
                        {
                            // newly added entry already exists since hidden form field has a nonce, 
                            // so must replace it with the latest one selected
                            let selectedPmType = pmType;

                            let newPM = {
                                Nonce: payload.nonce,
                                CardHolderName: payload.details.email,
                                AccountNumber: payload.details.payerId,
                                PaymentMethodTypeCode: selectedPmType,
                                label: payload.details.email,
                            };

                            this.addNewBraintreePm(selectedPmType, newPM);
                        });
                    },

                    onCancel: (data) => {
                        console.log('checkout.js payment cancelled', JSON.stringify(data, null, 2));
                    },

                    onError: (err) => {
                        console.error('checkout.js error', err);
                    },
                // @ts-check TODO: the create() function returns void if callback is provided ???                    
                }, '#paypal-button');
                /*.then( () => {
                    // The PayPal button will be rendered in an html element with the id
                    // `paypal-button`. This function will be called when the PayPal button
                    // is set up and ready to be used.
                    // $paypalContainer.addClass('loaded');
                    this.setState({braintreeTokenLoaded: true});
                });*/
                this.setState({braintreeTokenLoaded: true});
            });
    });
  };

  onChangeCheckbox(e: { target: { name: any; checked: any; }; }){
    let name = e.target.name;
    let value = e.target.checked;
    // console.debug(`PaymentMethod.onChangeCheckbox name=${name} value=${value}`);
    this.props.PaymentMethod[name] = value ? "Y" : "N";
    let {PaymentMethod, metadata, formBean, ctx} = this.props;
    let objectName = PaymentMethod._edgeName;
    let errorProps = {
      domainObject: PaymentMethod,
      attrName: name,
      formBean: formBean,
      objectName: objectName,
      objectId: PaymentMethod.Id,
    }
    clearError(errorProps);
  }

  onChangeInputValue = (value: string, name: string) => {
    if(!name) return;

    let {PaymentMethod, metadata, formBean, ctx} = this.props;
    let objectName = PaymentMethod._edgeName;
    let errorProps = {
      domainObject: PaymentMethod,
      attrName: name,
      formBean: formBean,
      objectName: objectName,
      objectId: PaymentMethod.Id,
    }

    if(name === 'dcExpiryDateMonth' || name === 'ccExpiryDateMonth'){
      if(!value) return;

      let currentExpiry = this.props.PaymentMethod.ExpiryDate;

      let expiryDate = currentExpiry ? LocalDate.parse(currentExpiry) : LocalDate.now();
      this.props.PaymentMethod.ExpiryDate = LocalDate.of(expiryDate.year(), Number(value), 1).toString();

      errorProps.attrName = 'ExpiryDate';
      clearError(errorProps);
    }
    else if(name === 'dcExpiryDateYear' || name === 'ccExpiryDateYear'){
      if(!value) return;
      let currentExpiry = this.props.PaymentMethod.ExpiryDate;

      let expiryDate = currentExpiry ? LocalDate.parse(currentExpiry) : LocalDate.now();
      this.props.PaymentMethod.ExpiryDate = LocalDate.of(Number(value), expiryDate.monthValue(), 1).toString();

      errorProps.attrName = 'ExpiryDate';
      clearError(errorProps);
    }
    else if(name === 'RoutingNumber'){
      if(!value) return;
      // first 3, bank id, follow by 6 digit bank transit number
      // validation: must be 9 digits
      this.props.PaymentMethod.BankId = value.substring(0,3);
      this.props.PaymentMethod.BankTransitNumber = value.substring(3);
      clearError(errorProps);
      ActionEvent.submitRequests(this.props.formBean, ["PaymentFacade.populateBankName"])
    }
    else if(name === 'AccountNumber'){
      this.props.PaymentMethod.AccountNumber = value;
      value = value || '';
      // @ts-ignore isNaN(number) !!!
      if(!isNaN(value) && value.length > 4) {
        let maskingPartLength = value.length - 4;
        let maskedAccount = '*'.repeat(maskingPartLength) + value.substring(maskingPartLength);
        this.props.PaymentMethod.MaskedAccountNumber = maskedAccount;
      }
      const {selectedCategory} = this.state;

      // if it's directDebits, then do not need to validate card type
      if (selectedCategory != "DD") {
        this.props.PaymentMethod.PaymentMethodTypeCode = this.identifyCardType(value, selectedCategory);
      }
      clearError(errorProps);
      this.calculateConvFee();
    }
    else {
      this.props.PaymentMethod[name] = value;
      clearError(errorProps);
    }
  }

  // TODO: e could be Event or directly value !!!
  onChangeInput(e:any, name: string){
    let value = '';
    if(e.target) value = e.target.value;
    else value = e;

    if(e.target) name = e.target.name;
    else name = name;

    this.props.PaymentMethod[name] = value;

    let {PaymentMethod, metadata, formBean, ctx} = this.props;
    let objectName = PaymentMethod._edgeName;
    let errorProps = {
      domainObject: PaymentMethod,
      attrName: name,
      formBean: formBean,
      objectName: objectName,
      objectId: PaymentMethod.Id,
    }
    clearError(errorProps);

    if(name === 'PaymentMethodTypeCode') this.calculateConvFee();

  }

  calculateConvFee() {
    let {PaymentMethod} = this.props;
    let category = PaymentMethod.PaymentMethodCategory;
    let pmType = PaymentMethod.PaymentMethodTypeCode;

    if(!category || (category!= 'LAST_USED_PM' && !pmType)) {
      return;
    }
    let recalculateConvFee = true;

    if(recalculateConvFee) {
      ActionEvent.submitRequests(this.props.formBean, ["PaymentFacade.calculateConvenienceFee"]);
    }
  }

  identifyCardType(cardNumber: string, categ: string | undefined) {
    // first check if card number passess validation
    var regexp = /^[0-9\*]+$/;
    var rVISA = /^4/;
    var rMC = /^(5[1-5]|2[2-7])/;
    var rAMEX = /^3[47]/;
    var rDISC = /^(6011|65)/;
    if (!regexp.test(cardNumber)) {
      return '';
    }
    if (rVISA.test(cardNumber)) {
      return (categ == 'CC' ? 'VISA' : 'VISA_DEBIT');
    }
    if (rMC.test(cardNumber)) {
      return (categ == 'CC' ? 'MC' : 'MC_DEBIT');
    }
    if (rAMEX.test(cardNumber)) {
      return 'AMEX';
    }
    if (rDISC.test(cardNumber)) {
      return (categ == 'CC' ? 'DISC' : 'DISC_DEBIT');
    }
    return null;
  }
  getLastUsedMaskedAccount(acctNumber: string){
    if(!acctNumber) return '';
    return acctNumber.indexOf("-") > 0 ? acctNumber.split("-")[1] : acctNumber
  }

  getAmazonError = (errorsObj: { [x: string]: any; CardHolderName?: any; AccountNumber?: any; PaymentMethodTypeCode?: any; }) =>{
    let error = [];
    if(errorsObj.CardHolderName) error.push(parseError(errorsObj.CardHolderName.message, {label:'Card Holder Name'}));
    if(errorsObj.AccountNumber) error.push(parseError(errorsObj.AccountNumber.message, {label:'Account Number'}));
    if(errorsObj.PaymentMethodTypeCode) error.push(parseError(errorsObj.PaymentMethodTypeCode.message, {label:'Account Type'}));

    return error.length > 0 ? error.join(',') : null;
  }

  getVenmoError = (errorsObj: { [x: string]: any; CardHolderName?: any; AccountNumber?: any; PaymentMethodTypeCode?: any; Nonce?: any; }) =>{
    let error = [];
    if(errorsObj.CardHolderName) error.push(parseError(errorsObj.CardHolderName.message, {label:'Card Holder Name'}));
    if(errorsObj.AccountNumber) error.push(parseError(errorsObj.AccountNumber.message, {label:'Account Number'}));
    if(errorsObj.PaymentMethodTypeCode) error.push(parseError(errorsObj.PaymentMethodTypeCode.message, {label:'Account Type'}));
    if(errorsObj.Nonce && errorsObj.Nonce.message) error.push(parseError(errorsObj.Nonce.message, {label:'Nonce'}));

    return error.length > 0 ? error.join(',') : null;
  }

  render() {
    const {
      metadata,
      payWithPreviousPmSupported
    } = this.props
    const {
      properties,
      validPaymentMethods
    } = metadata;
    const {selectedCategory, accountNumberOnMount} = this.state
    let {amazonClientId, amazonMerchantId, amazonSandbox} = this.props;
    let {PaymentMethod, paymentMethodDef, customerWallets} = this.props;

    paymentMethodDef = toJS(paymentMethodDef);
    if (!paymentMethodDef) paymentMethodDef = [];
    let pmCodes = paymentMethodDef.map((pm) => pm.PaymentMethodTypeCode);
    let lastPM = null;
    let walletEntries = [] as CustomerWallet[];
    if(customerWallets && customerWallets.length > 0){
      lastPM =  customerWallets.find((wallet) => wallet.LastUsedPm);
      walletEntries = customerWallets.filter((wallet) => !wallet.LastUsedPm);
    }

    let validPM = !validPaymentMethods || validPaymentMethods.length == 0 ? pmCodes : validPaymentMethods; // if validPaymentMethods has empty value, then select all pm codes

    let creditCards = codesByCategory.creditCards.filter(pmCode => pmCodes.indexOf(pmCode) >= 0 && validPM.indexOf(pmCode) >= 0)
    let debitCards = codesByCategory.debitCards.filter(pmCode => pmCodes.indexOf(pmCode) >= 0 && validPM.indexOf(pmCode) >= 0)
    let directDebits = codesByCategory.directDebits.filter(pmCode => pmCodes.indexOf(pmCode) >= 0 && validPM.indexOf(pmCode) >= 0)
    let braintreePms = codesByCategory.braintree.filter(pmCode => pmCodes.indexOf(pmCode) >= 0 && validPM.indexOf(pmCode) >= 0);
    let amazonPms = codesByCategory.amazon.filter(pmCode => pmCodes.indexOf(pmCode) >= 0 && validPM.indexOf(pmCode) >= 0);

    let {xs, sm, md, lg} = properties;

    let errorsObj = PaymentMethod._errors || {};

    let amazonErrorPresent = selectedCategory && selectedCategory === 'AMAZON_PAY' && this.getAmazonError(errorsObj);
    let amazonError =  this.state.amazonError && amazonErrorPresent ? this.state.amazonError + ", " + this.getAmazonError(errorsObj)
                      : this.state.amazonError ? this.state.amazonError
                      : amazonErrorPresent ? this.getAmazonError(errorsObj) : '';

    let venmoErrorPresent = selectedCategory && selectedCategory === 'VENMO' && this.getVenmoError(errorsObj);
    let venmoError =  this.state.venmoError && venmoErrorPresent ? this.state.venmoError + ", " + this.getVenmoError(errorsObj)
                      : this.state.venmoError ? this.state.venmoError
                      : venmoErrorPresent ? this.getVenmoError(errorsObj) : '';

    let accountNumberError = errorsObj.AccountNumber ? errorsObj.AccountNumber.message : null;
    let reEnterAccountNumberError = errorsObj.ReEnterAccountNumber ? errorsObj.ReEnterAccountNumber.message : null;
    let expiryError = errorsObj.ExpiryDate ? errorsObj.ExpiryDate.message : null;
    let cardHolderNameError = errorsObj.CardHolderName ? errorsObj.CardHolderName.message : null;
    let cvvError = errorsObj.Cvv ? errorsObj.Cvv.message : null;
    let bankIdError = errorsObj.BankId ? errorsObj.BankId.message : '';
    let fiNameError = errorsObj.FiName ? errorsObj.FiName.message : '';
    let transitNumberError = errorsObj.BankTransitNumber ? errorsObj.BankTransitNumber.message : '';

    let acceptDDTCError = errorsObj.AcceptDDAgreementFlag ? errorsObj.AcceptDDAgreementFlag.message : '';
    let pmTypeCodeError = errorsObj.PaymentMethodTypeCode ? errorsObj.PaymentMethodTypeCode.message : '';
    let isPaypalButtonReady = !this.state.loadingClientToken && this.state.braintreeTokenLoaded;
    let {
      BankId,
      BankTransitNumber,
      CardHolderName,
      Cvv,
      AccountNumber,
      ReEnterAccountNumber,
      MaskedAccountNumber,
      ExpiryDate,
      PaymentMethodTypeCode,
      FiName,
      AcceptDDAgreementFlag,
      SaveForReuseFlag,
    } = toJS(PaymentMethod);
    let expYear = 'YYYY', expMonth = 'MM';

    if(ExpiryDate) {
      let expDateObj = LocalDate.parse(ExpiryDate);
      expYear = expDateObj.year()+"";
      expMonth = ('0' + (expDateObj.monthValue()));
      expMonth = expMonth.substring(expMonth.length - 2, expMonth.length);
    }
    let routingNumber = '';
    if(BankId && BankTransitNumber) {
      routingNumber = BankId + BankTransitNumber;
    }
    let routingError = '';
    if(!!bankIdError || !!transitNumberError) {
      //user may not know about bankId or transit number etc
      if(routingNumber) {
        routingError = 'Please enter the valid Routing Number'
      } else {
        routingError = 'Please enter the Routing Number'
      }
    }

    // such as paypal will show the detailed payment method information after selection in the separate window/popup/service
    let newlyAddedPms = [];
    for(let key in this.state.newlyAdded){
      let newlyAddedCategory = key+"_NEWLY_ADDED";
      let newPM = this.state.newlyAdded[key];
      newlyAddedPms.push(
        <MDBCard key={key}>
          <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
            this.toggleCollapse(newlyAddedCategory, e)}}>
            <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!=newlyAddedCategory} icon="circle"/>
            <PaymentMethodIcons typeCodes={newPM.PaymentMethodTypeCode}/>
            <h3>{newPM.label}</h3>
          </div>
        </MDBCard>
      );
    }
    let braintreePmsLabels = {
      'PAYPAL_ACCOUNT': 'PayPal',
      'PAYPAL_CREDIT': 'PayPal Credit',
      'VENMO': 'Venmo'
    } as {[key:string]:string}

    let merchant = {
      amazonClientId: amazonClientId,
      amazonSellerId: amazonMerchantId,
      sandbox: amazonSandbox
    }

    let venmoDisabled = !isMobileDevice();
    let venmoUnavailableMsg = 'Want to pay with Venmo? Add your Venmo account to your wallet with your mobile device to pay on any device after';

    let wallet = [];
    for(let idx=0; idx<walletEntries!.length; idx++){
      let walletPM = walletEntries![idx];
      let key = walletPM.ProfileCode;
      let walletCategory = "WALLET"+idx + "_" + key;

      wallet.push(
        <MDBCard key={walletCategory}>
          <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
            this.toggleCollapse(walletCategory, e)}}>
            <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!=walletCategory} icon="circle"/>
            <PaymentMethodIcons typeCodes={walletPM.PaymentMethodType}/>
            <h3>{walletPM.MaskedAccountNumber}</h3>
            <span className={'ui-renderer-payment-method-side-text'}>(Wallet)</span>
          </div>
        </MDBCard>
      );
    }

    let ACHReEnterEnabled = this.isACHReEnterEnabled();
    return (
        <Col xs={xs} sm={sm} md={md} lg={lg} className="md-accordion paymentMethod">
          {/*{categoryError && <MDBAlert color="danger" >{categoryError}</MDBAlert>}*/}
          {newlyAddedPms}
          {wallet}
          { (lastPM && payWithPreviousPmSupported) &&
            <MDBCard>
              <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
                this.toggleCollapse("LAST_USED_PM", e)}}>
                <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!='LAST_USED_PM'} icon="circle"/>
                <PaymentMethodIcons typeCodes={lastPM.PaymentMethodType}/>
                  {/* If it's eCheck, show account number (exclude routing number) */}
                  <h3>{lastPM.MaskedAccountNumber}</h3>
                <span className={'ui-renderer-payment-method-side-text'}>(Last Used)</span>
              </div>
              <MDBCollapse id="LAST_USED_PM" isOpen={selectedCategory}>
                <MDBCardBody className="paymentMethod-container">
                  {/* If it's eCheck, show account number (include routing number)/ bank name  */}
                  <div><PaymentMethodIcons typeCodes={lastPM.PaymentMethodType}/>
                    <small>{lastPM.MaskedAccountNumber}</small>
                  </div>
                  <div><small>{directDebits.includes(lastPM.PaymentMethodType) ? lastPM.FiName : "Expires:**/**"}</small></div>
                </MDBCardBody>
              </MDBCollapse>
            </MDBCard>
          }
          {(amazonPms && amazonPms.length > 0) &&
          amazonPms.map((pm, idx) => {
            return (
                <MDBCard key={idx} >
                  <div className={"ui-renderer-payment-method-header"} onClick={ (e) => {
                    this.toggleCollapse(pm,e)}}>
                    <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!=pm} icon="circle"/>
                    <PaymentMethodIcons typeCodes={pm}/>
                    <h3>{this.state.AmazonPayLabel}</h3>
                  </div>

                  <MDBCollapse id={pm} isOpen={selectedCategory}>
                    {selectedCategory === pm && this.state.showAmazonCheckout &&
                    <AmazonButton onAmazonError = {this.amazonError} updateAmazonStatus={this.updateAmazonStatus} merchant={merchant} clickable={true}/>
                    }
                  </MDBCollapse>
                  {amazonError && <div className={'invalid-feedback'}>{amazonError}</div>}
                </MDBCard>
            )

          })
          }
          { (braintreePms && braintreePms.length > 0) &&

          braintreePms.map((pm,idx) => {
            let isDisabled = pm.startsWith("VENMO") && venmoDisabled;
            let isVenmo = pm.startsWith("VENMO");
            return (
            <MDBCard key={idx} className={isDisabled ? "disabled-payment-method" : null}>
              <div className={"ui-renderer-payment-method-header"} onClick={isDisabled ? (()=>{}) : (e) => {
                this.toggleCollapse(pm,e)}}>
                <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!=pm} icon="circle"/>
                <PaymentMethodIcons typeCodes={pm}/>
                <small className={"disabled-pm-reason"}>{isDisabled && venmoUnavailableMsg}</small>
                  <h3>{braintreePmsLabels[pm]}</h3>
              </div>
              <MDBCollapse id={pm} isOpen={selectedCategory}>
                {selectedCategory === pm &&
                 // only show one paypal button
                  <div className="button-load-container paypal-load-container">
                    { (!isPaypalButtonReady) &&
                    <div className="button-load-spinner">
                      <MDBSpinner small />
                    </div>
                    }
                    {!this.state.loadingClientToken &&

                    (
                      pm.startsWith("PAYPAL") ?
                        <div id="paypal-button"></div> :
                        <div id="venmo-button" onClick={this.onClickVenmoButton.bind(this)} style={{background: `${process.env.PUBLIC_URL}/images/payment-methods/VENMO.png`}}></div>
                    )

                    }
                  </div>

                }

              </MDBCollapse>
              {isVenmo && venmoError && <div className={'invalid-feedback'}>{venmoError}</div>}
            </MDBCard>
          )})

          }
          {creditCards && creditCards.length > 0 &&
            <MDBCard>
              <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
                this.toggleCollapse("CC",e)}}>
                <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!='CC'} icon="circle"/>
                <PaymentMethodIcons typeCodes={creditCards}/>
                  <h3>Credit Cards</h3>
              </div>
              <MDBCollapse id="CC" isOpen={selectedCategory}>
                <MDBCardBody>
                  <MDBRow>
                    <Col md="9">
                    {/* accountNumberOnMount is set at the time of the component being rendered, if account number hasn't changed show hint instead of value, where hint has masked */}
                      <CreditCardInput value={(accountNumberOnMount && (accountNumberOnMount === AccountNumber)) ? '' : AccountNumber||''}
                                      error={parseError(accountNumberError, {label:'Card Number'})}
                                      required={true}
                                      name="ccCardNumber"
                                      label="Card Number"
                                      maxLength={16}
                                      onChangeHandler={(value)=>{this.onChangeInputValue(value, 'AccountNumber')}}
                      />  
                  </Col>
                  <Col md="3">
                    <Input value={Cvv} required error={parseError(cvvError, {label:'CVV'})} label="CVV" id='ccCvv' maxLength={4} type={"password"} autoComplete={"off"} onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'Cvv')}}/>
                  </Col>
                </MDBRow>
                <MDBRow>
                  <Col>
                    <div className={"invalid-feedback"} style={{display: expiryError ? 'block' : 'none'}}>{parseError(expiryError, {label:'Expiry Date'})}</div>

                      <MDBRow>
                        <Col md="9">
                          <MonthPicker
                            label="Expiration Month"
                            key={expMonth+'ccExpMonth'}
                            selected={expMonth}
                            name={"ccExpiryDateMonth"}
                            getValue={(value)=>{this.onChangeInputValue(value, 'ccExpiryDateMonth')}}
                          />
                        </Col>
                        <Col md="3">
                          <DropDownList
                            key={expYear+'ccExpYear'}
                            name="ccExpiryDateYear"
                            dataList={this.state.years}
                            label="Expiration Year"
                            className={'ui-test-input-required'}
                            required
                            hint="YYYY"
                            valueName={"value"}
                            valueText={"text"}
                            value={expYear}
                            onChange={(value: any)=>{this.onChangeInputValue(value, 'ccExpiryDateYear')}}
                          />
                        </Col>
                      </MDBRow>
                    </Col>
                  </MDBRow>
                  <Input required value={CardHolderName} error={parseError(cardHolderNameError, {label:'Card Holder Name'})} label="Card Holder Name" id='ccCardHolderName' onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'CardHolderName')}}/>
                </MDBCardBody>
              </MDBCollapse>
            </MDBCard>
          }
          {debitCards && debitCards.length > 0 &&
            <MDBCard>
              <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
                this.toggleCollapse( "DC",e)}}>
                <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!='DC'} icon="circle"/>
                <PaymentMethodIcons typeCodes={debitCards}/>
                <h3>Debit Cards</h3>
              </div>
              <MDBCollapse id="DC" isOpen={selectedCategory}>
                <MDBCardBody>
                  <MDBRow>
                    <Col md="9">
                      <Input
                        /*accountNumberOnMount is set at the time of the component being rendered, if account number hasn't changed show hint instead of value, where hint has masked*/
                        value={ (accountNumberOnMount && (accountNumberOnMount === AccountNumber)) ? null : AccountNumber}
                        hint={(accountNumberOnMount && (accountNumberOnMount === AccountNumber)) ? MaskedAccountNumber||undefined : undefined}
                        error={parseError(accountNumberError, {label:'Card Number'})}
                        required
                        name="dcCardNumber"
                        label="Card Number"
                        maxLength={16}
                        onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'AccountNumber')}}/>
                  </Col>
                  <Col md="3">
                    <Input value={Cvv} error={parseError(cvvError, {label:'CVV'})} required label="CVV" name="dcCvv" maxLength={4} type={"password"} autoComplete={"off"} onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'Cvv')}}/>
                  </Col>
                </MDBRow>
                <MDBRow>
                  <Col>
                    <div className={"invalid-feedback"} style={{display: expiryError ? 'block' : 'none'}}>{parseError(expiryError, {label:'Expiry Date'})}</div>
                    <MDBRow>
                      <Col md="9">
                        <MonthPicker
                            label="Expiration Month"
                            key={expMonth+'dcExpMonth'}
                            selected={expMonth}
                            name={"dcExpiryDateMonth"}
                            getValue={(value)=>{this.onChangeInputValue(value, 'dcExpiryDateMonth')}}
                        />
                      </Col>
                      <Col md="3">
                        <DropDownList
                            label="Expiration Year"
                            key={expYear+'dcExpYear'}
                            name="dcExpiryDateYear"
                            dataList={this.state.years}
                            className={'ui-test-input-required'}
                            required
                            hint="YYYY"
                            valueName={"value"}
                            valueText={"text"}
                            value={expYear}
                            onChange={(value: any)=>{this.onChangeInputValue(value, 'dcExpiryDateYear')}}
                        />
                      </Col>
                    </MDBRow>
                  </Col>
                </MDBRow>
                <Input required value={CardHolderName} error={parseError(cardHolderNameError, {label:'Card Holder Name'})} id='dcCardHolderName' label="Card Holder Name" onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'CardHolderName')}}/>
              </MDBCardBody>
            </MDBCollapse>
          </MDBCard>
          }
          {directDebits && directDebits.length > 0 &&
          <MDBCard>
            <div className={"ui-renderer-payment-method-header"} onClick={(e) => {
              this.toggleCollapse( "DD", e)}}>
              <MDBIcon className={'ui-renderer-payment-method-select'} far={selectedCategory!='DD'} icon="circle"/>
              <PaymentMethodIcons typeCodes={directDebits}/>
              <h3>eCheck / Bank Account</h3>
            </div>
            <MDBCollapse id="DD" isOpen={selectedCategory}>
              <MDBCardBody>
                <div className={"invalid-feedback"} style={{display: pmTypeCodeError ? 'block' : 'none'}}>{parseError(pmTypeCodeError, {label: 'Account Type'})}</div>
                <MDBRow>
                  <Col>
                    <MDBInput id="ddAccountTypeChq" checked={PaymentMethodTypeCode === 'CHQ'} type="radio" label="Checking" value="CHQ" 
                              name={'PaymentMethodTypeCode'} onChange={this.onChangeInput.bind(this)}/>
                  </Col>
                  <Col>
                    <MDBInput id="ddAccountTypeSav" checked={PaymentMethodTypeCode === 'SAV'} type="radio" label="Savings" value="SAV" 
                              name={'PaymentMethodTypeCode'} onChange={this.onChangeInput.bind(this)}/>
                  </Col>
                </MDBRow>
                <Input required error={parseError(routingError, {label:'Routing Number'})} value={routingNumber} 
                       id="ddRoutingNumber" label="Routing Number" 
                       onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'RoutingNumber')}}/>
                <Input required  error={parseError(accountNumberError, {label:'Account Number'})} value={AccountNumber} 
                       id="ddAccountNumber" label="Account Number" autoComplete={"off"} 
                       onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'AccountNumber')}}/>
                { ACHReEnterEnabled && 
                    <Input required  error={parseError(reEnterAccountNumberError, {label:'Re-Enter Account Number'})} 
                           value={ReEnterAccountNumber} 
                           id="ddReEnterAccountNumber" label="Re-Enter Account Number" autoComplete={"off"} 
                           onChangeHandler={(value: any)=>{
                                this.onChangeInputValue(value, 'ReEnterAccountNumber');
                            }}/>
                }       
                <Input required error={parseError(fiNameError, {label:'Bank Name'})} value={FiName} id="ddBankName" 
                       label="Bank Name" onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'FiName')}}/>
                <Input required error={parseError(cardHolderNameError, {label:'Account Holder Name'})} 
                       value={CardHolderName} id="ddAccountHolderName" label="Account Holder Name" 
                       onChangeHandler={(value: any)=>{this.onChangeInputValue(value, 'CardHolderName')}}/>
                <a href="https://secure1.paymentus.com/rotp/www/ach-agreement.html" target="_blank" >
                  <small>View Authorization Agreement for direct debit payment (ACH Debit).</small>
                </a>
                {/* TODO: need this box to be true before able to make the payment / next page */}
                <MDBInput className={!!acceptDDTCError ? 'is-invalid' : null} checked={AcceptDDAgreementFlag==='Y'} 
                          id={"acceptDDAgreement"} type="checkbox" filled label="I authorize ACH direct debit (ACH Debit)" 
                          name='AcceptDDAgreementFlag' onChange={this.onChangeCheckbox.bind(this)}>
                  <div className={"invalid-feedback"}>{parseError(acceptDDTCError, {label: 'Authorization'})}</div>
                </MDBInput>
              </MDBCardBody>
            </MDBCollapse>
          </MDBCard>
          }
          {payWithPreviousPmSupported && selectedCategory!='LAST_USED_PM' &&
          <MDBInput id="saveForReuseFlag" type='checkbox' filled name={'SaveForReuseFlag'}
           label="Use this payment method for future payments."
                checked={toBoolean(SaveForReuseFlag)}
           onChange={this.onChangeCheckbox.bind(this)}
          />}

        </Col>
    )
  }
}

export default observer(PaymentMethod);
